import React from "react";

const AddTestimonialChild = () => {
  return <div>AddTestimonialChild</div>;
};

export default AddTestimonialChild;
